module.exports = __webpack_public_path__ + "img/24.4c2b7461.jpg";